/* eslint-disable import/prefer-default-export */

import merge from 'lodash/merge';

import MenuTypeCard from '../shared/MenuTypeCard';
import MenuTypeList from '../shared/MenuTypeList';
import {
  ALIGNMENT,
  ALIGNMENT_LEFT,
  ALIGNMENT_RIGHT,
  LEFT_ALIGNED_NAV_ITEMS,
  NAV_TYPE,
  NAV_TYPE_PRIMARY,
  NAV_TYPE_SECONDARY,
  RIGHT_ALIGNED_NAV_ITEMS,
  variant1,
  variant2,
  variant3,
  variant4,
  variant5,
  variant6,
  variant7,
  variant8,
} from './constants';
import { HeaderBarButtonPadding } from '../styles/Header.styles';

// Primary Nav item display target
export const primaryNavItemDisplayTarget = Object.freeze({
  mobile: 'mobile',
  desktop: 'desktop',
  both: 'both',
});

/**
 * Get primary Nav Items based desired display target
 *
 * @param {object[]} items Primary nav items
 * @param {"mobile"| "desktop"} target Render target, desktop or mobile
 * @return {object[]}
 */
export const getPrimaryNavItems = (items, target, showRightMobileItems = false) => {
  if (!Array.isArray(items) || !items?.length) {
    return [];
  }

  return items
    .map(i => ({ ...i, key: i.itemName }))
    .filter(item => {
      const displayTarget = item?.displayTarget?.toLowerCase?.();
      const mobileAlignment = item.navAlignment?.toLowerCase() === RIGHT_ALIGNED_NAV_ITEMS;
      if (displayTarget === primaryNavItemDisplayTarget.both) {
        return true;
      }
      if (target === primaryNavItemDisplayTarget.mobile && displayTarget === target && !mobileAlignment) {
        return true;
      }
      if (target === primaryNavItemDisplayTarget.desktop && displayTarget === primaryNavItemDisplayTarget[target]) {
        return true;
      }
      if (
        target === primaryNavItemDisplayTarget.mobile &&
        displayTarget === target &&
        mobileAlignment &&
        showRightMobileItems
      ) {
        return true;
      }
      return false;
    });
};

export const useConfiguration = appNameConfig => {
  const { variant } = appNameConfig;
  const mainColumnDisplay = ['none', 'none', 'block'];
  let accordionItemBorderBottom;
  let accordionItemExternalLinkStyle = {};
  let activeNavItemArrowIconColor = 'black';
  let activeNavItemBackgroundColor;
  let activeNavItemBoxShadow;
  let contentContainerBorderBottomColor;
  let contentContainerBorderTopColor;
  let contentContainerBorderTopSize;
  let contentContainerLevel2Background;
  let drawerBodyPaddingTopMobile = 'zero';
  let drawerBodyPaddingXDesktop = 'xxs';
  let drawerBodyPaddingXMobile = 'zero';
  let findDealerLinkColor = '';
  let footerLastTitleHaveNoBorder = true;
  let getPrimaryNavItemsToRender = f => f;
  let headerBarHeight;
  let headerBarLangTextDecoration;
  let headerBarPaddingTop;
  let headerHeight;
  let headerHeightPx;
  let headerItemSubmenuItemMarginBottom;
  let headerLevel1TitlePaddingY;
  let headerLevel2AccordionContainerPaddingY;
  let headerLevel2TitlePaddingY;
  let headerLevel3AccordionContainerPaddingBottom;
  let headerLevel3AccordionContainerPaddingTop;
  let headerLevel3TitlePaddingLeft = 'xl';
  let headerLevel3TitlePaddingRight = 'xl';
  let headerLevel3TitlePaddingY;
  let isFindDealerIconLeftSide = false;
  let isFirstColumnBold = false;
  let isPrimaryLogo = true;
  let lastItemBottomBorderColor;
  let linkHasExternalIcon;
  let logoAlignment;
  let logoHeight;
  let logoMarginRightTablet;
  let logoWidth;
  let mainColumnFlex;
  let mainColumnHeight;
  let mainColumnMl;
  let mainColumnMr;
  let megaMenuGroupBackgroundColor;
  let megaMenuGroupColumnBgPadding;
  let megaMenuGroupCopySize;
  let megaMenuGroupFirstColumnFontWeight = 'default';
  let megaMenuGroupFirstColumnLeftPadding;
  let megaMenuGroupFirstColumnShadow;
  let megaMenuGroupHeaderFontWeight;
  const megaMenuSimplePaddingBottom = 'xl';
  let megaMenuSimplePaddingTop = 'xl';
  let megaMenuSimpleTopValue;
  let minimizedLogoAlignment = {};
  let minimizedLogoCenterAligned = false;
  let mobileMenuButtonColor;
  let mobileMenuButtonStyles = {};
  let mobileMenuLikeAccordion;
  let mobileMenuLikeDrawer = true;
  let navAnimationItemBottom;
  let navBorder;
  let navBorderColor;
  let navHeaderTitleFont = 'bold';
  let navHeading = 'default';
  let navHeadingFont = 'default';
  let navHeight;
  // NavItemLabel of set alignment type uses alternative color
  let navItemLabelAlternativeColorType;
  let navItemLabelDisplay;
  let navItemLabelFontSize;
  let navItemLabelLineHeight;
  let navItemLabelTextDecoration;
  let navItemLabelUnderline;
  let navItemPrimaryGroups = false;
  let navItemPrimaryHeight; // use only full describe ['64px', '64px', '64px']
  let navItemPrimaryLineHeight;
  let navItemPrimaryMaxHeight;
  let navItemSecondaryFontFamily;
  let navItemSecondaryFontSize;
  let navItemSecondaryHeight;
  let navItemSecondaryLineHeight;
  let navItemSecondaryMaxHeight;
  let navItemSecondaryPadding;
  let navItemUnderline;
  let navMenuItemFont = '';
  let navTypePrimary;
  let navTypeSecondary;
  let navTypeVariable;
  let pillDealerStatusFontFamily = 'default';
  let shouldNavLabelHoverGrey = false;
  let shouldUnderlineLinkNavItems = true;
  let showLanguageMenu = true;
  let showMegaMenuGroups;
  let showMegaMenuSimple;
  let showNavItemIcon;
  let showPlaceIcon;
  let showSecondaryMenuOnTop;
  let showTitleContentBorderBottomLevel2 = false;
  let stylesLogo = {};
  let stylesLogoColumn = () => {};
  let titleContentLevel1FontFamily;
  let titleContentLevel1FontSize = '16px';
  let titleContentLevel1LineHeight;
  let titleContentLevel2FontFamily;
  let titleContentLevel2FontSize;
  let titleContentLevel2LineHeight;
  let titleContentLevel3AccordionItemColor;
  let overideHeaderMegaMenuScrollTopPosition = false;

  switch (variant) {
    case variant7:
    case variant5:
      // HONDA_SITE_NAME
      isFirstColumnBold = false;
      titleContentLevel2FontSize = '14px';
      lastItemBottomBorderColor = 'transparent';
      getPrimaryNavItemsToRender = getPrimaryNavItems;
      accordionItemBorderBottom = '1px solid';
      titleContentLevel1FontFamily = 'bold';
      contentContainerBorderBottomColor = 'transparent';
      contentContainerBorderTopColor = 'red';
      contentContainerBorderTopSize = '4px';
      contentContainerLevel2Background = 'linear-gradient(180deg, rgba(240,240,240,1) 1px, rgba(250,250,250,1) 4px)';
      drawerBodyPaddingXDesktop = 's';
      drawerBodyPaddingXMobile = 's';
      headerBarHeight = '100%';
      headerBarLangTextDecoration = 'none';
      headerBarPaddingTop = 0;
      headerHeight = 64;
      megaMenuSimpleTopValue = 64;
      headerHeightPx = `${headerHeight}px`;
      headerItemSubmenuItemMarginBottom = 'default';
      isFindDealerIconLeftSide = true;
      linkHasExternalIcon = true;
      logoAlignment = 'center';
      logoMarginRightTablet = 0;
      mainColumnFlex = 1;
      mainColumnHeight = ['100%', '100%', '100%'];
      mainColumnMl = 'auto';
      mainColumnMr = undefined;
      megaMenuGroupBackgroundColor = false;
      megaMenuGroupCopySize = 'small';
      megaMenuGroupFirstColumnFontWeight = 'bold!important';
      megaMenuGroupFirstColumnShadow = false;
      megaMenuGroupFirstColumnLeftPadding = ['100px', '151px'];
      megaMenuGroupColumnBgPadding = true;
      megaMenuGroupHeaderFontWeight = 'bold';
      mobileMenuButtonColor = 'black';
      mobileMenuButtonStyles = {
        margin: 0,
      };
      mobileMenuLikeAccordion = true;
      mobileMenuLikeDrawer = false;
      navAnimationItemBottom = '0';
      navBorder = '2px solid transparent';
      navBorderColor = 'grey.3';
      navHeight = ['45px', '45px', headerHeightPx];
      navItemLabelAlternativeColorType = ALIGNMENT_RIGHT;
      navItemLabelDisplay = 'flex';
      navItemLabelFontSize = '14px';
      navItemLabelLineHeight = '18px';
      navItemLabelTextDecoration = 'none';
      navItemPrimaryGroups = true;
      navItemPrimaryHeight = ['45px', '45px', headerHeightPx];
      navItemPrimaryLineHeight = ['45px', '45px', headerHeightPx];
      navItemPrimaryMaxHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryFontFamily = 'bold';
      navItemSecondaryFontSize = '14px';
      navItemSecondaryHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryLineHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryMaxHeight = ['45px', '45px', headerHeightPx];
      navItemUnderline = true;
      navTypePrimary = NAV_TYPE_PRIMARY;
      navTypeSecondary = NAV_TYPE_SECONDARY;
      navTypeVariable = NAV_TYPE;
      shouldNavLabelHoverGrey = true;
      showLanguageMenu = false;
      showMegaMenuGroups = true;
      showNavItemIcon = true;
      showPlaceIcon = true;
      showSecondaryMenuOnTop = false;
      stylesLogo = {
        ml: [0, 0, 0],
      };
      stylesLogoColumn = ({ isOpenMenu }) => ({
        width: ['100%', '100%', 'auto'],
        justifyContent: 'space-between',
        flexDirection: isOpenMenu ? 'row-reverse' : 'row',
      });
      navHeading = 'bold';
      navHeadingFont = 'default';
      navHeaderTitleFont = 'bold';
      accordionItemExternalLinkStyle = {
        color: 'black',
        textDecoration: 'none',
        fontFamily: 'heading',
        fontSize: '14px',
        fontWeight: '400',
      };
      titleContentLevel3AccordionItemColor = '#4A4A4A';
      headerLevel1TitlePaddingY = '20px';
      headerLevel2TitlePaddingY = 's';
      headerLevel3TitlePaddingY = 'xs';
      headerLevel3TitlePaddingLeft = '56px';
      headerLevel3TitlePaddingRight = 'default';
      headerLevel2AccordionContainerPaddingY = 's';
      headerLevel3AccordionContainerPaddingTop = 'xs';
      headerLevel3AccordionContainerPaddingBottom = 'xs';
      shouldUnderlineLinkNavItems = false;
      findDealerLinkColor = 'blue';
      navMenuItemFont = 'bold';
      pillDealerStatusFontFamily = 'bold';
      break;

    case variant8:
      // PE header variant
      isFirstColumnBold = false;
      titleContentLevel2FontSize = '14px';
      lastItemBottomBorderColor = 'transparent';
      getPrimaryNavItemsToRender = getPrimaryNavItems;
      accordionItemBorderBottom = '1px solid';
      titleContentLevel1FontFamily = 'bold';
      contentContainerBorderBottomColor = 'transparent';
      contentContainerBorderTopColor = 'red';
      contentContainerBorderTopSize = '4px';
      contentContainerLevel2Background = 'linear-gradient(180deg, rgba(240,240,240,1) 1px, rgba(250,250,250,1) 4px)';
      drawerBodyPaddingXDesktop = 's';
      drawerBodyPaddingXMobile = 's';
      headerBarHeight = '100%';
      headerBarLangTextDecoration = 'none';
      headerBarPaddingTop = 0;
      headerHeight = 64;
      megaMenuSimpleTopValue = 64;
      headerHeightPx = `${headerHeight}px`;
      headerItemSubmenuItemMarginBottom = 'default';
      isFindDealerIconLeftSide = true;
      linkHasExternalIcon = true;
      logoAlignment = 'center';
      logoMarginRightTablet = 0;
      mainColumnFlex = 1;
      mainColumnHeight = ['100%', '100%', '100%'];
      mainColumnMl = 'auto';
      mainColumnMr = undefined;
      megaMenuGroupBackgroundColor = false;
      megaMenuGroupCopySize = 'small';
      megaMenuGroupFirstColumnFontWeight = 'bold!important';
      megaMenuGroupFirstColumnShadow = false;
      megaMenuGroupFirstColumnLeftPadding = ['165px', '187px'];
      megaMenuGroupColumnBgPadding = true;
      megaMenuGroupHeaderFontWeight = 'bold';
      mobileMenuButtonColor = 'black';
      mobileMenuButtonStyles = {
        margin: 0,
      };
      mobileMenuLikeAccordion = true;
      mobileMenuLikeDrawer = false;
      navAnimationItemBottom = '0';
      navBorder = '2px solid transparent';
      navBorderColor = 'grey.3';
      navHeight = ['45px', '45px', headerHeightPx];
      navItemLabelAlternativeColorType = ALIGNMENT_RIGHT;
      navItemLabelDisplay = 'flex';
      navItemLabelFontSize = '14px';
      navItemLabelLineHeight = '18px';
      navItemLabelTextDecoration = 'none';
      navItemPrimaryGroups = true;
      navItemPrimaryHeight = ['45px', '45px', headerHeightPx];
      navItemPrimaryLineHeight = ['45px', '45px', headerHeightPx];
      navItemPrimaryMaxHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryFontFamily = 'bold';
      navItemSecondaryFontSize = '14px';
      navItemSecondaryHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryLineHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryMaxHeight = ['45px', '45px', headerHeightPx];
      navItemUnderline = true;
      navTypePrimary = NAV_TYPE_PRIMARY;
      navTypeSecondary = NAV_TYPE_SECONDARY;
      navTypeVariable = NAV_TYPE;
      shouldNavLabelHoverGrey = true;
      showLanguageMenu = false;
      showMegaMenuGroups = true;
      showNavItemIcon = true;
      showPlaceIcon = true;
      showSecondaryMenuOnTop = false;
      stylesLogo = {
        ml: [0, 0, 0],
      };
      stylesLogoColumn = ({ isOpenMenu }) => ({
        width: ['100%', '100%', 'auto'],
        justifyContent: 'space-between',
        flexDirection: isOpenMenu ? 'row-reverse' : 'row',
      });
      navHeading = 'bold';
      navHeadingFont = 'default';
      navHeaderTitleFont = 'bold';
      accordionItemExternalLinkStyle = {
        color: 'black',
        textDecoration: 'none',
        fontFamily: 'heading',
        fontSize: '14px',
        fontWeight: '400',
      };
      titleContentLevel3AccordionItemColor = '#4A4A4A';
      headerLevel1TitlePaddingY = '20px';
      headerLevel2TitlePaddingY = 's';
      headerLevel3TitlePaddingY = 'xs';
      headerLevel3TitlePaddingLeft = '56px';
      headerLevel3TitlePaddingRight = 'default';
      headerLevel2AccordionContainerPaddingY = 's';
      headerLevel3AccordionContainerPaddingTop = 'xs';
      headerLevel3AccordionContainerPaddingBottom = 'xs';
      shouldUnderlineLinkNavItems = false;
      findDealerLinkColor = 'black';
      navMenuItemFont = 'bold';
      pillDealerStatusFontFamily = 'bold';
      break;

    case variant6:
    case variant4:
      // ACURA_SITE_NAME
      isFirstColumnBold = true;
      titleContentLevel2FontSize = '14px';
      lastItemBottomBorderColor = 'transparent';
      getPrimaryNavItemsToRender = getPrimaryNavItems;
      titleContentLevel1FontFamily = 'heading';
      contentContainerBorderBottomColor = 'grey.2';
      contentContainerBorderTopColor = 'blue';
      contentContainerBorderTopSize = '2.5px';
      activeNavItemBackgroundColor = 'darkBlue';
      activeNavItemBoxShadow = '0px 2px 19px 0px rgba(0, 0, 0, 0.08)';
      activeNavItemArrowIconColor = 'white';
      drawerBodyPaddingXDesktop = 's';
      drawerBodyPaddingXMobile = 'm';
      drawerBodyPaddingTopMobile = 'm';
      headerBarHeight = '100%';
      headerBarLangTextDecoration = 'none';
      headerBarPaddingTop = 0;
      headerHeight = 64;
      megaMenuSimpleTopValue = 64;
      headerHeightPx = `${headerHeight}px`;
      headerItemSubmenuItemMarginBottom = 'default';
      isFindDealerIconLeftSide = true;
      linkHasExternalIcon = true;
      logoAlignment = 'center';
      logoMarginRightTablet = 0;
      mainColumnFlex = 1;
      mainColumnHeight = ['100%', '100%', '100%'];
      mainColumnMl = 'auto';
      mainColumnMr = undefined;
      megaMenuGroupBackgroundColor = false;
      megaMenuGroupCopySize = 'small';
      megaMenuGroupFirstColumnFontWeight = 'bold!important';
      megaMenuGroupFirstColumnShadow = false;
      megaMenuGroupFirstColumnLeftPadding = ['186px', '237px'];
      megaMenuGroupHeaderFontWeight = 'bold';
      mobileMenuButtonColor = 'black';
      mobileMenuButtonStyles = {
        margin: 0,
      };
      mobileMenuLikeAccordion = true;
      mobileMenuLikeDrawer = false;
      navAnimationItemBottom = '0';
      navBorder = '2px solid transparent';
      navBorderColor = 'grey.3';
      navHeight = ['45px', '45px', headerHeightPx];
      navItemLabelDisplay = 'flex';
      navItemLabelFontSize = '14px';
      navItemLabelLineHeight = '18px';
      navItemLabelTextDecoration = 'none';
      navItemPrimaryGroups = true;
      navItemPrimaryHeight = ['45px', '45px', headerHeightPx];
      navItemPrimaryLineHeight = ['45px', '45px', headerHeightPx];
      navItemPrimaryMaxHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryFontFamily = 'bold';
      navItemSecondaryFontSize = '14px';
      navItemSecondaryHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryLineHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryMaxHeight = ['45px', '45px', headerHeightPx];
      navItemUnderline = true;
      navTypePrimary = NAV_TYPE_PRIMARY;
      navTypeSecondary = NAV_TYPE_SECONDARY;
      navTypeVariable = NAV_TYPE;
      shouldNavLabelHoverGrey = true;
      showLanguageMenu = false;
      showMegaMenuGroups = true;
      showNavItemIcon = true;
      showPlaceIcon = true;
      showSecondaryMenuOnTop = false;
      stylesLogo = {
        ml: [0, 0, 0],
      };
      stylesLogoColumn = ({ isOpenMenu }) => ({
        width: ['100%', '100%', 'auto'],
        justifyContent: 'space-between',
        flexDirection: isOpenMenu ? 'row-reverse' : 'row',
      });
      navHeading = 'heading';
      navHeaderTitleFont = 'heading';
      navHeadingFont = 'headingRegular';
      accordionItemExternalLinkStyle = {
        color: 'blue',
        textDecoration: 'underline',
        fontSize: '14px',
        fontWeight: '400',
      };
      titleContentLevel3AccordionItemColor = '#393939';
      minimizedLogoCenterAligned = true;
      minimizedLogoAlignment = {
        ml: '69px',
      };
      headerLevel1TitlePaddingY = 'm';
      headerLevel2TitlePaddingY = 's';
      headerLevel3TitlePaddingY = 'xs';
      headerLevel3TitlePaddingLeft = '56px';
      headerLevel3TitlePaddingRight = 'default';
      headerLevel2AccordionContainerPaddingY = 's';
      headerLevel3AccordionContainerPaddingTop = 's';
      headerLevel3AccordionContainerPaddingBottom = 'zero';
      isPrimaryLogo = false;
      shouldUnderlineLinkNavItems = false;
      findDealerLinkColor = 'darkBlue';
      navMenuItemFont = 'heading';
      pillDealerStatusFontFamily = 'heading';
      break;

    case variant3:
      // PSP_SITE_NAME
      headerBarHeight = '100%';
      headerBarLangTextDecoration = 'none';
      headerBarPaddingTop = [0, 0, '20px'];
      headerHeight = 104;
      headerHeightPx = `${headerHeight}px`;
      headerItemSubmenuItemMarginBottom = 'default';
      logoAlignment = 'flex-end';
      logoHeight = ['45px', '45px', headerHeight];
      logoMarginRightTablet = 0;
      mainColumnFlex = 1;
      mainColumnHeight = ['100%', '100%', '100%'];
      mainColumnMl = 'auto';
      mainColumnMr = undefined;
      megaMenuSimpleTopValue = 75;
      mobileMenuButtonColor = 'black';
      navHeading = 'bold';
      navHeight = ['45px', '45px', headerHeight];
      navItemLabelFontSize = '14px';
      navItemLabelLineHeight = '18px';
      navItemLabelTextDecoration = 'none';
      navItemLabelUnderline = true;
      navItemPrimaryHeight = ['30px', '30px', 'auto'];
      navItemPrimaryLineHeight = ['30px', '30px', '35px'];
      navItemPrimaryMaxHeight = ['30px', '30px', 'initial'];
      navItemSecondaryFontFamily = 'default';
      navItemSecondaryFontSize = '12px';
      navItemSecondaryLineHeight = ['30px', '30px', '30px'];
      navItemSecondaryMaxHeight = ['30px', '30px', '30px'];
      navItemSecondaryPadding = HeaderBarButtonPadding;
      navTypePrimary = NAV_TYPE_PRIMARY;
      navTypeSecondary = NAV_TYPE_SECONDARY;
      navTypeVariable = NAV_TYPE;
      showMegaMenuSimple = true;
      showSecondaryMenuOnTop = true;
      megaMenuSimplePaddingTop = 'm';
      break;

    case variant2:
      // MARINE_SITE_NAME
      headerBarHeight = '100%';
      headerBarPaddingTop = [0, 0, '20px'];
      headerHeight = 104;
      headerHeightPx = `${headerHeight}px`;
      headerItemSubmenuItemMarginBottom = 'default';
      logoWidth = ['71px', '71px', '160px'];
      mainColumnFlex = 1;
      mainColumnHeight = ['100%', '100%', '100%'];
      mainColumnMl = 'auto';
      mainColumnMr = undefined;
      megaMenuSimpleTopValue = 75;
      mobileMenuButtonColor = 'black';
      navHeading = 'bold';
      navHeight = ['45px', '45px', headerHeightPx];
      navItemLabelUnderline = true;
      navItemPrimaryHeight = ['30px', '30px', 'auto'];
      navItemPrimaryLineHeight = ['30px', '30px', '35px'];
      navItemPrimaryMaxHeight = ['30px', '30px', 'initial'];
      navItemSecondaryFontFamily = 'default';
      navItemSecondaryFontSize = '12px';
      navItemSecondaryLineHeight = ['30px', '30px', '30px'];
      navItemSecondaryMaxHeight = ['30px', '30px', '30px'];
      navItemSecondaryPadding = HeaderBarButtonPadding;
      navTypePrimary = NAV_TYPE_PRIMARY;
      navTypeSecondary = NAV_TYPE_SECONDARY;
      navTypeVariable = NAV_TYPE;
      showMegaMenuSimple = true;
      showSecondaryMenuOnTop = true;
      megaMenuSimplePaddingTop = 'm';
      break;

    case variant1:
    default:
      headerBarHeight = '100%';
      headerBarPaddingTop = 0;
      headerHeight = 75;
      headerHeightPx = `${headerHeight}px`;
      headerItemSubmenuItemMarginBottom = 'default';
      logoWidth = ['71px', '71px', '115px'];
      mainColumnMr = 'auto';
      megaMenuSimpleTopValue = 75;
      mobileMenuButtonColor = 'white';
      navHeading = 'bold';
      navHeight = ['45px', '45px', headerHeightPx];
      navItemLabelUnderline = true;
      navItemPrimaryHeight = ['45px', '45px', 'auto'];
      navItemPrimaryLineHeight = ['45px', '45px', headerHeightPx];
      navItemPrimaryMaxHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryFontFamily = 'bold';
      navItemSecondaryFontSize = '14px';
      navItemSecondaryLineHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryMaxHeight = ['45px', '45px', headerHeightPx];
      navItemSecondaryPadding = HeaderBarButtonPadding;
      navTypePrimary = ALIGNMENT_LEFT;
      navTypeSecondary = ALIGNMENT_RIGHT;
      navTypeVariable = ALIGNMENT;
      showMegaMenuSimple = true;
      showSecondaryMenuOnTop = false;
      break;
  }

  // re Override variant styles based
  switch (variant) {
    // Honda Footer variant
    case variant7:
      drawerBodyPaddingXMobile = 'zero';
      footerLastTitleHaveNoBorder = false;
      lastItemBottomBorderColor = 'grey.2';
      showTitleContentBorderBottomLevel2 = true;
      titleContentLevel1FontFamily = 'bold';
      titleContentLevel1FontSize = ['16px', '16px', '18px'];
      titleContentLevel1LineHeight = '26px';
      titleContentLevel2FontFamily = 'default';
      titleContentLevel2FontSize = '14px';
      titleContentLevel2LineHeight = '22px';
      break;
    // Acura Footer variant
    case variant6:
      drawerBodyPaddingTopMobile = 'zero';
      drawerBodyPaddingXMobile = 'zero';
      showTitleContentBorderBottomLevel2 = true;
      titleContentLevel1FontSize = ['16px', '16px', '18px'];
      titleContentLevel1LineHeight = '26px';
      titleContentLevel2FontSize = '14px';
      titleContentLevel2LineHeight = '22px';
      break;
    // PE variant
    case variant5:
      overideHeaderMegaMenuScrollTopPosition = true;
      break;
    default:
      break;
  }

  return merge(
    {
      getPrimaryNavItemsToRender,
      headerHeight,
      megaMenuSimpleTopValue,
      headerHeightPx,
      linkHasExternalIcon,
      mobileMenuLikeAccordion,
      mobileMenuLikeDrawer,
      navItemLabelAlternativeColorType,
      navItemLabelUnderline,
      navItemPrimaryGroups,
      navItemUnderline,
      navTypePrimary,
      navTypeSecondary,
      navTypeVariable,
      showLanguageMenu,
      showMegaMenuGroups,
      showMegaMenuSimple,
      showNavItemIcon,
      showPlaceIcon,
      showSecondaryMenuOnTop,
      isFirstColumnBold,
      overideHeaderMegaMenuScrollTopPosition,
      styles: {
        findDealerLinkColor,
        navMenuItemFont,
        drawerBody: {
          1: {
            paddingX: [drawerBodyPaddingXMobile, drawerBodyPaddingXMobile, drawerBodyPaddingXDesktop],
            pt: [drawerBodyPaddingTopMobile, drawerBodyPaddingTopMobile, 'zero'],
          },
          2: { paddingX: 0, paddingY: headerLevel2AccordionContainerPaddingY },
          3: {
            paddingX: 0,
            paddingTop: headerLevel3AccordionContainerPaddingTop,
            paddingBottom: headerLevel3AccordionContainerPaddingBottom,
          },
        },
        accordion: {
          item: {
            1: {
              borderBottom: accordionItemBorderBottom,
              borderBottomColor: 'grey.2',
              lastItemBottomBorderColor,
            },
            2: { iconColor: activeNavItemArrowIconColor },
            3: {},
          },
          title: {
            1: () => ({ minHeight: '56px', paddingLeft: 'xs' }),
            2: ({ theme, isActive }) => ({
              minHeight: '42px',
              paddingX: 'l',
              background: isActive ? `${theme.colors[activeNavItemBackgroundColor]}` : 'none',
              boxShadow: isActive ? activeNavItemBoxShadow : 'none',
            }),
            3: () => ({ minHeight: '42px' }),
          },
          titleContent: {
            1: ({ isExternal, theme }) => ({
              fontFamily: titleContentLevel1FontFamily,
              fontSize: titleContentLevel1FontSize,
              lineHeight: titleContentLevel1LineHeight,
              py: headerLevel1TitlePaddingY,
              linkStyle: isExternal
                ? { ...accordionItemExternalLinkStyle, color: theme.colors[accordionItemExternalLinkStyle.color] }
                : {},
            }),
            2: ({ isActive }) => ({
              fontFamily: titleContentLevel2FontFamily ?? navHeadingFont,
              fontSize: titleContentLevel2FontSize,
              lineHeight: titleContentLevel2LineHeight,
              color: isActive && activeNavItemBackgroundColor ? 'white' : 'black',
              py: headerLevel2TitlePaddingY,
              showTitleContentBorderBottomLevel2,
            }),
            3: () => ({
              fontFamily: titleContentLevel2FontFamily ?? navHeadingFont,
              color: titleContentLevel3AccordionItemColor,
              py: headerLevel3TitlePaddingY,
              pl: headerLevel3TitlePaddingLeft,
              pr: headerLevel3TitlePaddingRight,
            }),
          },
          contentContainer: {
            1: ({ theme, showChildren }) => ({
              borderTop: showChildren
                ? `${contentContainerBorderTopSize} solid ${theme.colors[contentContainerBorderTopColor]}`
                : '0 solid transparent',
              // : `${contentContainerBorderTopSize} solid transparent`,
              borderBottom: '1px solid',
              borderBottomColor: contentContainerBorderBottomColor,
            }),
            2: () => ({
              background: contentContainerLevel2Background,
            }),
            3: () => ({}),
          },
        },
        nav: {
          height: navHeight,
        },
        /* For Auto brands, keep logoWidth and logoHeight empty in variants, instead pass values
        directly in styled comp */
        logo: {
          width: logoWidth,
          height: logoHeight,
          mr: logoMarginRightTablet,
          ...stylesLogo,
        },
        logoColumn: ({ isOpenMenu }) => ({
          alignItems: logoAlignment,
          ...stylesLogoColumn({ isOpenMenu }),
        }),
        headerBar: {
          height: headerBarHeight,
          paddingTop: headerBarPaddingTop,
          borderBottom: { borderBottom: navBorder, borderBottomColor: navBorderColor },
        },
        headerMenuLanguageStyle: {
          textDecoration: headerBarLangTextDecoration,
        },
        navItemPrimary: {
          maxHeight: navItemPrimaryMaxHeight,
          height: navItemPrimaryHeight,
          heightNumber: headerHeight,
          lineHeight: navItemPrimaryLineHeight,
          megaMenuSimpleTopValue,
          megaMenuSimplePaddingBottom,
          megaMenuSimplePaddingTop,
        },
        navItemLabel: {
          display: navItemLabelDisplay,
          fontSize: navItemLabelFontSize,
          lineHeight: navItemLabelLineHeight,
          textDecoration: navItemLabelTextDecoration,
          fontFamily: navHeading,
        },
        headerItemSubmenuItem: {
          marginBottom: headerItemSubmenuItemMarginBottom,
        },
        navItemSecondary: {
          fontSize: navItemSecondaryFontSize,
          fontFamily: navItemSecondaryFontFamily,
          maxHeight: navItemSecondaryMaxHeight,
          height: navItemSecondaryHeight,
          lineHeight: navItemSecondaryLineHeight,
          paddingOverlap: navItemSecondaryPadding,
        },
        navAnimationItem: {
          bottom: navAnimationItemBottom,
        },
        mainColumn: {
          height: mainColumnHeight,
          display: mainColumnDisplay,
          mr: mainColumnMr,
          ml: mainColumnMl,
          flex: mainColumnFlex,
        },
        mobileMenuButtonIcon: {
          bgColor: mobileMenuButtonColor,
        },
        mobileMenuButton: mobileMenuButtonStyles,
        megaMenuGroup: {
          backgroundColor: megaMenuGroupBackgroundColor,
          copySize: megaMenuGroupCopySize,
          columnBgPadding: megaMenuGroupColumnBgPadding,
          firstColumn: {
            fontWeight: megaMenuGroupFirstColumnFontWeight,
            shadow: megaMenuGroupFirstColumnShadow,
            firstColumnLeftPadding: megaMenuGroupFirstColumnLeftPadding,
          },
          header: {
            fontWeight: megaMenuGroupHeaderFontWeight,
          },
        },
        pill: {
          dealerStatusFontFamily: pillDealerStatusFontFamily,
        },
      },
      isFindDealerIconLeftSide,
      shouldNavLabelHoverGrey,
      navHeading,
      navHeaderTitleFont,
      navHeadingFont,
      minimizedLogoCenterAligned,
      minimizedLogoAlignment,
      footerLastTitleHaveNoBorder,
      isPrimaryLogo,
      shouldUnderlineLinkNavItems,
    },
    appNameConfig,
  );
};

const mapFnType = {
  SubMenuCardItemSection: MenuTypeCard,
  SubMenuListItemSection: MenuTypeList,
};

export const reduceItems = (
  menuItems = [],
  { navTypePrimary = NAV_TYPE_PRIMARY, navTypeSecondary = NAV_TYPE_SECONDARY, navTypeVariable = NAV_TYPE },
) =>
  menuItems?.reduce(
    (acc, item) => {
      const newItem = {
        ...item,
        RenderComponent: mapFnType[item?.items?.[0]?.itemDisplayName] || null,
      };

      if (item?.[navTypeVariable] === navTypePrimary) {
        const columnKey = item.navAlignment === ALIGNMENT_LEFT ? LEFT_ALIGNED_NAV_ITEMS : RIGHT_ALIGNED_NAV_ITEMS;
        acc.primaryItems.push(newItem);
        acc[`${columnKey}PrimaryItems`].push(newItem);
      }
      if (item?.[navTypeVariable] === navTypeSecondary) {
        acc.secondaryItems.push(item);
      }
      return acc;
    },
    { primaryItems: [], leftPrimaryItems: [], rightPrimaryItems: [], secondaryItems: [] },
  );
